import { render, staticRenderFns } from "./RecuperoPass.vue?vue&type=template&id=67e49c87&scoped=true"
import script from "./RecuperoPass.vue?vue&type=script&lang=js"
export * from "./RecuperoPass.vue?vue&type=script&lang=js"
import style0 from "./RecuperoPass.vue?vue&type=style&index=0&id=67e49c87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e49c87",
  null
  
)

export default component.exports